import { useEffect } from "react";
import { COMPANY } from "../data";

const Wrap = ({ title, children, testId }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main className="pt-28 pb-24 bg-white min-h-screen" data-testid={testId}>
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#1A3C1A]">{title}</h1>
        <div className="mt-10 space-y-6 text-[#2A2A2A] text-sm md:text-base leading-relaxed [&_h2]:font-heading [&_h2]:font-bold [&_h2]:text-lg [&_h2]:text-[#1A3C1A] [&_h2]:mt-8">
          {children}
        </div>
      </div>
    </main>
  );
};

export default function Impressum() {
  return (
    <Wrap title="Impressum" testId="impressum-page">
      <h2>Angaben gemäß § 5 TMG</h2>
      <p>
        Zimmerei Müller GmbH &amp; Co. KG<br />
        Talstraße 5<br />
        97799 Zeitlofs-Weißenbach
      </p>
      <h2>Vertreten durch</h2>
      <p>Andreas Müller &amp; Richard Müller (Geschäftsführer)</p>
      <h2>Kontakt</h2>
      <p>
        Telefon: {COMPANY.phone}<br />
        Fax: {COMPANY.fax}<br />
        E-Mail: {COMPANY.email}
      </p>
      <h2>Registereintrag</h2>
      <p>Eintragung im Handelsregister. Registergericht und Registernummer: [Bitte ergänzen]</p>
      <h2>Umsatzsteuer-ID</h2>
      <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: [Bitte ergänzen]</p>
      <h2>Berufsbezeichnung</h2>
      <p>Zimmerer- und Dachdeckermeisterbetrieb. Zuständige Kammer: Handwerkskammer für Unterfranken.</p>
      <h2>Streitschlichtung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
        <a href="https://ec.europa.eu/consumers/odr/" className="text-[#2A5C2A] underline" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a>.
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </Wrap>
  );
}

export function Datenschutz() {
  return (
    <Wrap title="Datenschutzerklärung" testId="datenschutz-page">
      <h2>1. Datenschutz auf einen Blick</h2>
      <p>
        Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen
        Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit
        denen Sie persönlich identifiziert werden können.
      </p>
      <h2>2. Verantwortliche Stelle</h2>
      <p>
        Zimmerei Müller GmbH &amp; Co. KG<br />
        Talstraße 5, 97799 Zeitlofs-Weißenbach<br />
        Telefon: {COMPANY.phone}<br />
        E-Mail: {COMPANY.email}
      </p>
      <h2>3. Datenerfassung auf dieser Website</h2>
      <p>
        Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen — z.&nbsp;B. über
        das Kontaktformular. Andere Daten werden automatisch beim Besuch der Website durch unsere
        IT-Systeme erfasst (z.&nbsp;B. Browser, Betriebssystem, Uhrzeit des Seitenaufrufs).
      </p>
      <h2>4. Kontaktformular</h2>
      <p>
        Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem
        Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der
        Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht
        ohne Ihre Einwilligung weiter. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
      </p>
      <h2>5. Cookies</h2>
      <p>
        Diese Website verwendet ausschließlich technisch notwendige Cookies sowie — nach Ihrer
        Einwilligung — optionale Statistik-Cookies. Ihre Auswahl wird lokal in Ihrem Browser gespeichert.
      </p>
      <h2>6. Google Maps</h2>
      <p>
        Diese Seite nutzt den Kartendienst Google Maps zur Darstellung unseres Standorts. Anbieter ist
        Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Beim Laden der Karte
        werden Daten an Google übertragen. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.
      </p>
      <h2>7. Ihre Rechte</h2>
      <p>
        Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
        personenbezogenen Daten, deren Herkunft und Empfänger sowie den Zweck der Datenverarbeitung.
        Außerdem haben Sie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten sowie ein
        Beschwerderecht bei der zuständigen Aufsichtsbehörde.
      </p>
    </Wrap>
  );
}
